<template>
    <div class="main-container">
        <Navbar />
        <div data-bs-spy="scroll" data-bs-target="#navbar-example2" data-bs-offset="0" class="scrollspy-example" tabindex="0">
            <HeroBranding />

            <div class="feature-icon-list-area section-space--pb_120">
                <div class="container">
                    <div class="section-title-wrapper text-center section-space--mb_100">
                        <h2 class="section-title mb-30">Experienced in design and installation of physical and software energy systems and products!</h2>
                           <FeatureTwo />
                    </div>
                    <div class="container">
                        <FunFactOne />
                    </div>
                </div>
            </div>

            <div class="pricing-table-area bg-gray-2 pt-30" id="pricing">
                <div class="pricing-table-title-area position-relative">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="section-title-wrapper text-center section-space--mb_60">
                                    <h2 class="section-title font-width-light mb-15 wow move-up">Testimonials</h2>
                                    <TestimonialFour />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="box-image-area section-space--ptb_120" id="about">
                <div class="container">
                    <div class="section-title-wrapper text-center section-space--mb_60 wow move-up">
                        <h2 class="section-title mb-15">We are energy technologists and innovators!</h2>
                        <span class="section-text">Luszol started out as a solar installer, then moved on to designing systems and products optimised for their clients needs and locales.</span>
                    </div>
                     <AboutExpand />
                </div>
            </div>
                             
            <FooterMain />
            <!-- <OffcanvasSearchBox /> -->
        </div>
    </div>
</template>

<script>
    import Navbar from '../components/Navbar'
    import HeroBranding from '../components/HeroBranding'
    import AboutExpand from '../components/AboutExpand'
    import FeatureList from '../components/FeatureList'
    import RequireList from '../components/RequireList'
    import FeatureTwo from '../components/FeatureTwo'
    import ProgressCircle from '../components/ProgressCircle'
    import CurveShape from '../components/CurveShape'
    import Pricing from '../components/Pricing'
    import BrandLogo from '../components/BrandLogo'
    import Newsletter from '../components/Newsletter'
    import FooterMain from '../components/FooterMain'
    import OffcanvasSearchBox from '../components/OffcanvasSearchBox'
    import TestimonialFour from '../components/TestimonialFour'
    import FunFactOne from '../components/FunFactOne'
    
    export default {
        name: 'HomeBranding',
        components: {
            Navbar,
            HeroBranding,
            AboutExpand,
            FeatureList,
            RequireList,
            FeatureTwo,
            ProgressCircle,
            CurveShape,
            Pricing,
            BrandLogo,
            Newsletter,
            FooterMain,
            OffcanvasSearchBox,
            TestimonialFour,
            FunFactOne
        },
    }
</script>

